import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  titles: {
    draft: 'Ihre Bestellung (Kosten pro Monat)',
    main: 'Ihr Abonnement',
    billing_settings: 'Einstellungen für die Rechnungsstellung',
  },
  form: {
    billing_mode: {
      label: 'Abrechnungsmodus',
    },
    has_trial: {
      label: 'Kostenlose Probetage hinzufügen',
    },
    trial_days: {
      label: 'Wie viele Probetage sollten es sein?',
      placeholder: '21',
      validation: {
        required: 'Probetage sind erforderlich',
        min: '{{value}} ist der Mindestwert für die Probetage',
        max: '{{value}} ist der maximale Wert für die Probetage',
      },
    },
  },
  fields: {
    created_at: 'Erstellt am <strong>{{date}}</strong> von {{manager}}',
    updated_at: 'Zuletzt aktualisiert am <strong>{{date}}</strong> von <strong>{{manager}}</strong>',
    trial_ends_at: 'Auf Probe bis <strong>{{date}}</strong>',
    trial_days:
      'Die {{trialDays}}-tägige Testphase beginnt am Tag der Markteinführung und wird nach Ablauf der Testphase in Rechnung gestellt.',
    resumable_until: 'Wiederaufnehmbar bis <strong>{{date}}</strong>',
    ended_at: 'Beendet am <strong>{{date}}</strong>',
    next_bill_at: 'Nächste Rechnung unter <strong>{{date}}</strong>',
    product: 'Produkt',
    quantity: 'Menge',
    price: 'Nettopreis',
    tax: 'Steuer',
    amount: 'Betrag',
    net: 'Netto',
    tax_percentage: 'Steuer {{rate}}%',
    total: 'Gesamtkosten pro Monat',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Gebühr von der Zahlungsmethode',
    [BillingMode.InternalInvoicing]: 'Gebühr aus Verkäufen',
  },
  labels: {
    included: 'inklusive',
    sales_based_discount:
      'Der Warenkorb enthält einen Artikel mit variablem Preis. Der tatsächliche Preis wird bei der Erstellung/Aktualisierung des Abonnements auf Grundlage der Verkaufszahlen des letzten Monats berechnet.',
  },
  buttons: {
    edit: 'Bearbeiten',
    cancel: 'Abbrechen',
    resume: 'Aufnehmen',
  },
  modals: {
    cancel_subscription: {
      title: 'Abonnement von {{company}} kündigen?',
      description:
        'Dadurch wird das ausgewählte Abonnement, einschließlich <strong>{{products}}</strong> (<strong>{{total}} Gesamtbetrag</strong>), gekündigt. Das Abonnement kann bis zum <strong>{{billingAnchor}}</strong> noch wieder aufgenommen werden, falls der Kunde seine Meinung ändert. Wird das Abonnement bis dahin nicht wieder aufgenommen, muss ein neues Abonnement erstellt werden.',
    },
    resume_subscription: {
      title: 'Abonnement bei {{company}} wieder aufnehmen?',
      description:
        'Dadurch wird das ausgewählte Abonnement, einschließlich <strong>{{products}}</strong>, wieder aufgenommen. Dem Restaurant werden ab dem <strong>{{billingAnchor}}</strong> jeden Monat <strong>{{total}}</strong> in Rechnung gestellt.',
    },
  },
  toasts: {
    cancel_subscription:
      'Wenn Sie Ihr Abonnement kündigen möchten, wenden Sie sich bitte per Telefon oder E-Mail an Ihre {{provider}} Kontaktperson. Ihre Kontaktperson wird das Abonnement für Sie sofort kündigen.',
    failed_to_cancel_subscription:
      'Bei der Kündigung des Abonnements ist ein Fehler aufgetreten. Bitte wenden Sie sich an den technischen Support.',
    resume_subscription:
      'Wenn Sie Ihr Abonnement wieder aufnehmen möchten, wenden Sie sich bitte telefonisch oder per E-Mail an Ihren Ansprechpartner bei {{provider}}. Ihr Ansprechpartner wird das Abonnement umgehend für Sie wieder aufnehmen.',
    failed_to_resume_subscription:
      'Bei der Wiederaufnahme des Abonnements ist ein Fehler aufgetreten. Bitte wenden Sie sich an den technischen Support.',
  },
};
